import MainNavItems from './MainNavItems'
export default MainNavItems



// WEBPACK FOOTER //
// ./src/molecules/MainNavItems/index.js